export const SESSIONS_PAGE_LIMIT = 10;
